import { render } from "./InviteUserModal.vue?vue&type=template&id=a5ef71f4"
import script from "./InviteUserModal.vue?vue&type=script&lang=js"
export * from "./InviteUserModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__